import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AccordionModule } from "ngx-bootstrap/accordion";
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MultiSelectModule } from 'primeng/multiselect';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TableModule } from 'primeng/table';
import { TreeSelectModule } from 'primeng/treeselect';
import { AccountFilterComponent } from './account/account-filter/account-filter.component';
import { AccountTreePopupComponent } from './account/account-tree-popup/account-tree-popup.component';
import { UserAccountListTableComponent } from './account/account-tree-popup/user-account-list-table/user-account-list-table.component';
import { UserAccountListNodeComponent } from './account/account-tree-popup/user-account-list/user-account-list-node/user-account-list-node.component';
import { UserAccountListComponent } from './account/account-tree-popup/user-account-list/user-account-list.component';
import { LinkedAccountInputComponent } from './account/linked-account-input/linked-account-input.component';
import { LinkedAccountPopupComponent } from './account/linked-account-popup/linked-account-popup.component';
import { AdvancedSearchCustomerPopupComponent } from './customer/advanced-search-customer-popup/advanced-search-customer-popup.component';
import { AdvancedSearchFromResultComponent } from './customer/advanced-search-form-result/advanced-search-form-result.component';
import { AdvancedSearchFromComponent } from './customer/advanced-search-form/advanced-search-form.component';
import { InputNumberFormatComponent } from './input-number-format/input-number-format.component';
import { LoanDetailSummaryComponent } from './loan/loan-detail-summary/loan-detail-summary.component';
import { OffBalanceAccountStatementPopupComponent } from './off-balance-account-statement-popup/off-balance-account-statement-popup.component';
import { SavingAgreementInterestCalculationPopupComponent } from './saving-agreement/saving-agreement-interest-calculation-popup/saving-agreement-interest-calculation-popup.component';
import { SavingAgreementInterestPaymentPopupComponent } from './saving-agreement/saving-agreement-interest-payment-popup/saving-agreement-interest-payment-popup.component';
import { SavingAgreementSummaryComponent } from './saving-agreement/saving-agreement-summary/saving-agreement-summary.component';
import { PrintReceiptPopupComponent } from './print-receipt-popup/print-receipt-popup.component';
import { InputSearchComponent } from './input-search/input-search.component';
import {
    CollateralDisbursementPopupComponent as CollateralDisbursementPopupComponent
} from "@app/shared/collateral-disbursement-popup/collateral-disbursement-popup.component";
import {
    CollateralAdjustmentPopupComponent
} from "@app/shared/collateral-adjustment-popup/collateral-adjustment-popup.component";
import {
    CollateralRestitutionPopupComponent
} from "@app/shared/collateral-restitution-popup/collateral-restitution-popup.component";
import {InputNumberModule} from "primeng/inputnumber";
import { ImportResultPopupComponent } from './import-result-popup/import-result-popup.component';
import { GuaranteeDisbursementPopupComponent } from './guarantee-disbursement-popup/guarantee-disbursement-popup.component';
import { GuaranteeRestitutionPopupComponent } from './guarantee-restitution-popup/guarantee-restitution-popup.component';
import { GuaranteeAdjustmentPopupComponent } from './guarantee-adjustment-popup/guarantee-adjustment-popup.component';
import {ExceptionPopupComponent} from "@app/shared/exception/exception-popup.component";
import { SelectCustomerNotePopupComponent } from './customer/select-customer-note-popup/select-customer-note-popup.component';
import { CustomerNoteNodeComponent } from './customer/select-customer-note-popup/customer-note-node/customer-note-node.component';
import { SelectLoanNotePopupComponent } from './loan/select-loan-note-popup/select-loan-note-popup.component';
import { LoanNoteNodeComponent } from './loan/select-loan-note-popup/loan-note-node/loan-note-node.component';
import { CollateralNoteNodeComponent } from './select-collateral-note-popup/collateral-note-node/collateral-note-node.component';
import { SelectCollateralNotePopupComponent } from './select-collateral-note-popup/select-collateral-note-popup.component';
import { GuaranteeNoteNodeComponent } from './select-guarantee-note-popup/guarantee-note-node/guarantee-note-node.component';
import { SelectGuaranteeNotePopupComponent } from './select-guarantee-note-popup/select-guarantee-note-popup.component';
import { SelectSavingAgreementNotePopupComponent } from './saving-agreement/select-saving-agreement-note-popup/select-saving-agreement-note-popup.component';
import { SavingAgreementNoteNodeComponent } from './saving-agreement/select-saving-agreement-note-popup/saving-agreement-note-node/saving-agreement-note-node.component';
import { ButtonComponent } from "@app/shared/button/button.component";
import { ModalTitleComponent } from "@app/shared/modal-title/modal-title.component";
import { IdentityDocumentsComponent } from "@app/shared/identity-documents/identity-documents.component";
import { PrimengModule } from "@app/shared/primeng/primeng.module";
import { CalendarModule } from "primeng/calendar";
import { TooltipModule } from 'primeng/tooltip';
import { SavingAgreementInterestAdjustmentPopupComponent } from './saving-agreement/saving-agreement-interest-adjustment-popup/saving-agreement-interest-adjustment-popup.component';
import { StatusDropdownComponent } from "@app/shared/status-dropdown/status-dropdown.component";
import { NgSelectModule } from '@ng-select/ng-select';
import { CurrencyDropdownComponent } from "@app/shared/currency-dropdown/currency-dropdown.component";
import { CustomDropdownComponent } from "@app/shared/custom-dropdown/custom-dropdown.component";
import { CustomSwitcherComponent } from "@app/shared/custom-switcher/custom-switcher.component";
import { PeriodDropdownComponent } from './period-dropdown/period-dropdown.component';
import { DateTimePickerComponent } from './date-time-picker/date-time-picker.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';

@NgModule({
    imports: [
        TranslateModule,
        InputSwitchModule,
        ConfirmDialogModule,
        OverlayPanelModule,
        InputTextareaModule,
        AccordionModule.forRoot(),
        RadioButtonModule,
        CommonModule,
        FormsModule,
        DropdownModule,
        InputNumberModule,
        CalendarModule,
        PrimengModule,
        TooltipModule,
        TranslateModule,
        NgSelectModule,
        NgxIntlTelInputModule
    ],
    declarations: [
        AdvancedSearchFromComponent,
        AdvancedSearchCustomerPopupComponent,
        AdvancedSearchFromResultComponent,
        AccountFilterComponent,
        AccountTreePopupComponent,
        LinkedAccountPopupComponent,
        LinkedAccountInputComponent,
        UserAccountListComponent,
        UserAccountListNodeComponent,
        UserAccountListTableComponent,
        LoanDetailSummaryComponent,
        InputNumberFormatComponent,
        OffBalanceAccountStatementPopupComponent,
        SavingAgreementSummaryComponent,
        SavingAgreementInterestCalculationPopupComponent,
        SavingAgreementInterestAdjustmentPopupComponent,
        SavingAgreementInterestPaymentPopupComponent,
        PrintReceiptPopupComponent,
        InputSearchComponent,
        CollateralDisbursementPopupComponent,
        CollateralAdjustmentPopupComponent,
        CollateralRestitutionPopupComponent,
        GuaranteeDisbursementPopupComponent,
        GuaranteeRestitutionPopupComponent,
        GuaranteeAdjustmentPopupComponent,
        ImportResultPopupComponent,
        ExceptionPopupComponent,
        CustomerNoteNodeComponent,
        SelectCustomerNotePopupComponent,
        SelectLoanNotePopupComponent,
        LoanNoteNodeComponent,
        SelectSavingAgreementNotePopupComponent,
        SavingAgreementNoteNodeComponent,
        SelectCollateralNotePopupComponent,
        CollateralNoteNodeComponent,
        SelectGuaranteeNotePopupComponent,
        GuaranteeNoteNodeComponent,
        ButtonComponent,
        ModalTitleComponent,
        IdentityDocumentsComponent,
        StatusDropdownComponent,
        CurrencyDropdownComponent,
        CustomDropdownComponent,
        CustomSwitcherComponent,
        PeriodDropdownComponent,
        DateTimePickerComponent
    ],
    exports: [
        TableModule,
        DialogModule,
        MultiSelectModule,
        TreeSelectModule,
        CheckboxModule,
        TranslateModule,
        InputSwitchModule,
        ConfirmDialogModule,
        OverlayPanelModule,
        InputTextareaModule,
        AccordionModule,
        RadioButtonModule,
        RadioButtonModule,
        AccountFilterComponent,
        CommonModule,
        FormsModule,
        DropdownModule,
        CalendarModule,
        TooltipModule,
        LinkedAccountPopupComponent,
        LinkedAccountInputComponent,
        AccountTreePopupComponent,
        UserAccountListComponent,
        UserAccountListNodeComponent,
        UserAccountListTableComponent,
        LoanDetailSummaryComponent,
        AdvancedSearchFromComponent,
        AdvancedSearchCustomerPopupComponent,
        AdvancedSearchFromResultComponent,
        InputNumberFormatComponent,
        OffBalanceAccountStatementPopupComponent,
        SavingAgreementSummaryComponent,
        SavingAgreementInterestCalculationPopupComponent,
        SavingAgreementInterestAdjustmentPopupComponent,
        SavingAgreementInterestPaymentPopupComponent,
        PrintReceiptPopupComponent,
        InputSearchComponent,
        CollateralDisbursementPopupComponent,
        CollateralAdjustmentPopupComponent,
        CollateralRestitutionPopupComponent,
        GuaranteeDisbursementPopupComponent,
        GuaranteeRestitutionPopupComponent,
        GuaranteeAdjustmentPopupComponent,
        ImportResultPopupComponent,
        ExceptionPopupComponent,
        SelectCustomerNotePopupComponent,
        SelectLoanNotePopupComponent,
        LoanNoteNodeComponent,
        SelectSavingAgreementNotePopupComponent,
        SavingAgreementNoteNodeComponent,
        SelectCollateralNotePopupComponent,
        CollateralNoteNodeComponent,
        SelectGuaranteeNotePopupComponent,
        GuaranteeNoteNodeComponent,
        ButtonComponent,
        ModalTitleComponent,
        IdentityDocumentsComponent,
        StatusDropdownComponent,
        CurrencyDropdownComponent,
        CustomDropdownComponent,
        CustomSwitcherComponent,
        PeriodDropdownComponent,
        DateTimePickerComponent,
        NgxIntlTelInputModule
    ]
})
export class SharedModule { }
